import LeaderboardLanding from './leaderboard-landing'

export default LeaderboardLanding
